import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import { WarningAmber, ErrorOutline, InfoOutlined } from '@mui/icons-material';
import { ISystemAlert } from 'services/SchoolClass/types';

interface Props {
  alerts: ISystemAlert[];
}

export function ClassAlertsList({ alerts }: Props) {
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" fontWeight="bold" color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <WarningAmber color="warning" fontSize="small" /> Alertas Recentes
      </Typography>
      
      {alerts.length > 0 ? (
        <Box 
          sx={{ 
            flexGrow: 1,
            maxHeight: 160, 
            overflowY: 'auto',
            pr: 1, 
            scrollBehavior: 'smooth',
            overscrollBehavior: 'contain',        
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { background: 'transparent' },
            '&::-webkit-scrollbar-thumb': { 
              backgroundColor: 'divider', 
              borderRadius: '4px' 
            },
            '&::-webkit-scrollbar-thumb:hover': { 
              backgroundColor: 'text.secondary' 
            }
          }}
        >
          <Stack spacing={2}>
            {alerts.map(alert => (
              <Box key={alert.id} sx={{ p: 2, borderRadius: 2, bgcolor: 'background.default', border: '1px solid', borderColor: 'divider', display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                <Box sx={{ color: alert.type === 'error' ? 'error.main' : 'warning.main', mt: 0.25 }}>
                  {alert.type === 'error' ? <ErrorOutline fontSize="small" /> : <InfoOutlined fontSize="small" />}
                </Box>
                <Box>
                  <Typography variant="body2" color="text.primary">{alert.text}</Typography>
                  <Typography variant="caption" color="text.secondary">{alert.time}</Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>Nenhum alerta para esta turma.</Typography>
      )}
    </Paper>
  );
}